var React = require('react');

function Alice (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30 60C13.44 60 0 46.56 0 30C0 13.44 13.44 0 30 0C46.56 0 60 13.44 60 30C60 46.56 46.56 60 30 60ZM16.26 39.68C18.42 41.82 24.16 43.12 30 43.14C35.84 43.12 41.58 41.84 43.74 39.68C49.1 34.36 36.08 13.96 30 13.92C23.92 13.96 10.92 34.36 16.26 39.68Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"9.99952","y1":"50.0011","x2":"33.9995","y2":"26.0011","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#C926FF","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#4A26FF","key":1})]))]);
}

Alice.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Alice;

Alice.default = Alice;
